// Mapping dos tiers de Premium do Cabal Liberty.
// Backend retorna `serviceKind` em PremiumInfo — aqui convertemos
// em nome, cor e icone consistentes com a identidade Liberty.
//
// Hierarquia (definida pelo servidor do jogo):
//   1 = melhor  -> Lendário  (dourado/laranja-fogo)
//   2 = medio   -> Mítico    (vermelho/magenta)
//   3 = basico  -> Épico     (roxo)
//   0 = free    -> Free      (cinza, default quando nao ha premium)
//
// Pra trocar nomes/cores, basta editar este arquivo — todo o site le daqui.

export type PremiumTier = {
  serviceKind: number;
  name: string;
  shortName: string;   // usado em badges estreitos
  color: string;       // cor primaria do tier
  glow: string;        // cor do glow (box-shadow)
  bgSoft: string;      // bg translucido (badges/cards)
  borderSoft: string;  // border translucida
  description: string;
  isPaid: boolean;
};

const DEFAULT_FREE: PremiumTier = {
  serviceKind: 0,
  name: 'Free',
  shortName: 'Free',
  color: '#64748b',
  glow: 'rgba(100, 116, 139, 0.25)',
  bgSoft: 'rgba(100, 116, 139, 0.10)',
  borderSoft: 'rgba(100, 116, 139, 0.25)',
  description: 'Acesso gratuito ao jogo.',
  isPaid: false,
};

export const PREMIUM_TIERS: Record<number, PremiumTier> = {
  1: {
    serviceKind: 1,
    name: 'Lendário',
    shortName: 'Lendário',
    color: '#FFD700',
    glow: 'rgba(255, 215, 0, 0.35)',
    bgSoft: 'rgba(255, 215, 0, 0.12)',
    borderSoft: 'rgba(255, 215, 0, 0.35)',
    description: 'Plano definitivo — todos os beneficios com o maximo de bonus.',
    isPaid: true,
  },
  2: {
    serviceKind: 2,
    name: 'Mítico',
    shortName: 'Mítico',
    color: '#E11D48',
    glow: 'rgba(225, 29, 72, 0.35)',
    bgSoft: 'rgba(225, 29, 72, 0.12)',
    borderSoft: 'rgba(225, 29, 72, 0.35)',
    description: 'Plano intermediario — bonus fortes com excelente custo-beneficio.',
    isPaid: true,
  },
  3: {
    serviceKind: 3,
    name: 'Épico',
    shortName: 'Épico',
    color: '#A855F7',
    glow: 'rgba(168, 85, 247, 0.35)',
    bgSoft: 'rgba(168, 85, 247, 0.12)',
    borderSoft: 'rgba(168, 85, 247, 0.35)',
    description: 'Plano de entrada — os recursos essenciais premium.',
    isPaid: true,
  },
  0: DEFAULT_FREE,
};

/** Resolve um serviceKind em tier. Caso invalido, retorna Free. */
export function getPremiumTier(serviceKind?: number | null): PremiumTier {
  if (!serviceKind) return DEFAULT_FREE;
  return PREMIUM_TIERS[serviceKind] ?? DEFAULT_FREE;
}

/** Tier "ativo" considerando premium expirado = Free. */
export function getActiveTier(
  serviceKind?: number | null,
  daysLeft?: number
): PremiumTier {
  if (!serviceKind || !daysLeft || daysLeft <= 0) return DEFAULT_FREE;
  return getPremiumTier(serviceKind);
}
